import React from 'react';
import { createRoot } from 'react-dom/client';

// Base
import BlankNav from '../../components/v5/base/simple_nav';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('nav-content');

  if(element) {
    const root = createRoot(element);
    root.render(<BlankNav />);
  }
});
